import PropTypes from 'prop-types'
import React, { Component } from 'react'
import i18n from 'simple-react-i18n'
import DtoCity from '../../../../../home/dto/DtoCity'
import { Grid } from '@mui/material'

class CityInformationPanel extends Component {
    constructor(props) {
        super(props)
    }

    putInformation = (title, value) => {
        const finalValue = value ? value : ''
        return (
            <Grid container>
                <Grid size={{ lg: 3 }} sx={{ textAlign: 'right' }}>
                    <h6 className='bold'>{title}</h6>
                </Grid>
                <Grid size={{ lg: 9 }}>
                    <h6>{finalValue}</h6>
                </Grid>
            </Grid>
        )
    }

    getData = () => {
        const situationsOptions = [
            { value: 0, label: '' },
            { value: 1, label: i18n.rural },
            { value: 2, label: i18n.urban },
        ]

        const citySituation = situationsOptions.map((e) => {
            if (e.value == this.props.city.situation) {
                return e.label
            }
            return ''
        })

        return (
            <div>
                {this.putInformation(i18n.inseeCode, this.props.city.code)}
                {this.putInformation(i18n.name, this.props.city.name)}
                {this.putInformation(i18n.area, this.props.city.area)}
                {this.putInformation(i18n.situation, citySituation)}
                {this.putInformation(i18n.country, 'France')}
            </div>
        )
    }

    render() {
        if (this.props.city && this.props.city.code) {
            return (
                <Grid size={9}>
                    <Grid container>
                        <Grid size={12} sx={{ padding: 0 }}>
                            {this.getData()}
                        </Grid>
                    </Grid>
                </Grid>
            )
        }
        return null
    }
}
CityInformationPanel.propTypes = {
    city: PropTypes.instanceOf(DtoCity).isRequired,
}
CityInformationPanel.defaultProps = {
    city: {},
}
export default CityInformationPanel
